// useCustomBadwordsFilter.tsx

import { useEffect, useState } from 'react';
import Filter from 'bad-words';

const useCustomBadwordsFilter = () => {
    const [customBadwords, setCustomBadwords] = useState<string[]>([]);

    useEffect(() => {
        // Carica il file JSON con le bad words personalizzate
        fetch('/assets/badwords_new.json')
            .then((response) => response.json())
            .then((data) => {
                // Estrai l'array di bad words dal JSON
                const customBadwordsArray = data.badwords || [];
                setCustomBadwords(customBadwordsArray);
            })
            .catch((error) => {
                console.error('Errore nel caricamento del file JSON:', error);
            });
    }, []); // L'effetto si verifica solo al montaggio del componente

    const filterBadwords = (text: string) => {
        // Inizializza il filtro di bad words
        const filter = new Filter();

        // Aggiungi le bad words personalizzate al filtro
        customBadwords.forEach((word) => {
            filter.addWords(word);
        });

        // Applica il filtro e restituisci il testo filtrato
        return filter.clean(text);
    };

    return {
        filterBadwords,
        customBadwords,
    };
};

export default useCustomBadwordsFilter;
